const YMD_PATTERN = /^\d{4}-\d{2}-\d{2}/

export function getTodayYmdBogota(now: Date = new Date()): string {
  return new Intl.DateTimeFormat('en-CA', {
    timeZone: 'America/Bogota',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  }).format(now)
}

export function normalizeFechaEntregaYmd(raw: unknown): string {
  if (raw == null) return ''
  const value = String(raw).trim()
  if (!value) return ''
  const ymd = value.slice(0, 10)
  return YMD_PATTERN.test(ymd) ? ymd : ''
}

export function getFechaEntregaFromListOrder(order: {
  fecha_entrega?: unknown
  extraDetails?: { fecha_entrega?: unknown } | null
}): unknown {
  if (order.fecha_entrega != null && String(order.fecha_entrega).trim() !== '') {
    return order.fecha_entrega
  }
  return order.extraDetails?.fecha_entrega
}

/**
 * Un pedido entra a Crear Envío si ya llegó el día de entrega o ya pasó.
 * Sin fecha de entrega no se oculta (no hay restricción).
 */
export function isPedidoVisibleEnCrearEnvio(
  fechaEntrega: unknown,
  todayYmd: string = getTodayYmdBogota()
): boolean {
  const ymd = normalizeFechaEntregaYmd(fechaEntrega)
  if (!ymd) return true
  return ymd <= todayYmd
}
